import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";
import { ServiceDefinitionContext } from "./CustomServiceModel";

class ServiceDefinitionWithItsRelatedCombos implements ICheckable {
    public FullName: string;
    public NameWithDuration: string;
    public Name: string;

    public RelatedServiceDefinitionContexts: ServiceDefinitionContext[];

    public ServiceDefinitionId: string;
    public ServiceDefinitionDuration: number;
    public ServiceDefinitionSpecialityId: string;
    public LicenceOrganisationSpecialisationId: string;

    public HasCombo: boolean;
    public IsTeleconsultation: boolean;

    public GroupMax: number;

    public Id: string;
    public Checked: boolean;
    public Visible: boolean;
    public Target: CheckboxTarget;

    constructor() {
        this.Id = GuidHelper.NewGuid();
        this.Checked = false;
        this.Visible = true;
        this.Target = CheckboxTarget.Unassigned;

        this.RelatedServiceDefinitionContexts = [];
    }

    public static SortRelatedServiceDefinitions(model: ServiceDefinitionWithItsRelatedCombos): void {
        if (model.RelatedServiceDefinitionContexts != null && model.RelatedServiceDefinitionContexts.length > 0) {
            var standaloneService = ArrayHelper.Find(
                model.RelatedServiceDefinitionContexts,
                x => x.IsCombo == false
            );

            //  sort by name first
            model.RelatedServiceDefinitionContexts = ArrayHelper.SortDynamic(model.RelatedServiceDefinitionContexts, "Name");

            // if we have a standalone, move it to beginning of array
            if (standaloneService != null) {
                model.RelatedServiceDefinitionContexts = model.RelatedServiceDefinitionContexts.filter(x => x.Id != standaloneService.Id);
                model.RelatedServiceDefinitionContexts.unshift(standaloneService);
            }
        }
    }

    public static GetCustomServiceListHash(model: ServiceDefinitionWithItsRelatedCombos, filterChecked: boolean): string {
        var tmp = "";
        if (model.RelatedServiceDefinitionContexts != null) {
            if (filterChecked == true)
                model.RelatedServiceDefinitionContexts.filter(i => i.Checked === true).forEach(x => tmp += (x.Id + ","));
            else
                model.RelatedServiceDefinitionContexts.forEach(x => tmp += (x.Id + ","));
        }
        return tmp;
    }

    public static Clone(model: ServiceDefinitionWithItsRelatedCombos): ServiceDefinitionWithItsRelatedCombos {
        var tmpClone: ServiceDefinitionWithItsRelatedCombos = JSON.parse(JSON.stringify(model));
        return tmpClone;
    }

    public static SubItemHasError(model: ServiceDefinitionWithItsRelatedCombos): string[] {
        let error = [];
        if (model.GroupMax > 0)
            model.RelatedServiceDefinitionContexts.filter(i => i.Min > model.GroupMax || i.Max > model.GroupMax).map(y => error.push(y));

        let sumMax = 0;
        if (model.GroupMax > 0)
            model.RelatedServiceDefinitionContexts.forEach(i => {
                let currentMax = i.Max ? i.Max : 0;
                sumMax += currentMax;
            });
        if (sumMax > model.GroupMax)
            error.push({ Id: "ALL", Name: "" });

        model.RelatedServiceDefinitionContexts
            .filter(u => u.Min && u.Max > 0 && u.Min > u.Max)
            .forEach(x => error.push(x));

        if (error.length > 0)
            return [error[0].Id, error[0].Name];

        return null;
    }

    public static HasService(model: ServiceDefinitionWithItsRelatedCombos, service: ServiceDefinitionContext): boolean {
        return model.RelatedServiceDefinitionContexts.indexOfObject("Id", service.Id) > -1;
    }
}

export { ServiceDefinitionWithItsRelatedCombos };
